import { gql, NetworkStatus, useQuery } from "@apollo/client";
import { shiftStreamClient } from "../../../graphql/client";

export const PAGE_SIZE = 50;

export const GET_WARNINGS = gql`
  query getWarnings($offset: Int!, $limit: Int!) {
    warnings(offset: $offset, limit: $limit) {
      total

      data {
        id

        message

        firstSeenAt
        lastSeenAt

        account {
          id
          name
          provider
          url
        }

        streamId

        shift {
          id
          startTime
          endTime

          sourceAccount {
            id
            accountName
          }

          role {
            id
            name
          }

          venue {
            id
            name
          }
        }

        member {
          id
          firstName
          lastName
        }

        extra
        screenshot
        archived
      }
    }
  }
`;

export const useWarnings = (page = 1) => {
  const safePage = Math.max(1, page);
  const offset = (safePage - 1) * PAGE_SIZE;

  const { data, previousData, loading, networkStatus, refetch } = useQuery(
    GET_WARNINGS,
    {
      client: shiftStreamClient,
      variables: {
        offset,
        limit: PAGE_SIZE
      },
      fetchPolicy: "cache-and-network",
      notifyOnNetworkStatusChange: true,
      onError: error => {
        throw error;
      }
    }
  );

  // Keep pagination metadata stable while the next page is loading.
  const resolvedData = data || previousData;

  const total = resolvedData?.warnings?.total || 0;
  const totalPages = Math.max(1, Math.ceil(total / PAGE_SIZE));

  return {
    loading: loading || networkStatus === NetworkStatus.refetch,
    warnings: resolvedData?.warnings?.data || [],
    total,
    totalPages,
    page: safePage,
    refetch
  };
};
